import { ThemeProvider } from '@emotion/react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { createTheme, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useAppSelector } from 'app/hooks';
import IC_CONTACT from 'assets/icons/ic_contact_white.svg';
import IC_USER from 'assets/icons/ic_person_white.svg';
import NormalButton from 'components/atoms/Button/NormalButton';
import SmallButton from 'components/atoms/Button/SmallButton';
import SimpleInputText from 'components/molecules/InputText/SimpleInputText';
import { selectAuth } from 'features/auth/authSlice';
import React, { useEffect, useState } from 'react';
const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const ParaText = styled(Typography)(({ theme }) => ({
  fontSize: '1.2rem',
  color: '#C1C1C1',
}));

const SmallText = styled(Typography)(({ theme }) => ({
  fontSize: '.8rem',
  color: '#ffffff',
}));

const TitleText = styled(Typography)(({ theme }) => ({
  fontSize: '2.4rem',
  fontWeight: 'bold',
  color: '#ffffff',
}));

const Icon = styled('img')(({ theme }) => ({
  width: '16px',
  height: '16px',
  marginRight: '10px',
}));

const CustomTextBox = styled(Box)(({ theme }) => ({}));

interface ProfileSidebarProps {
  editing?: boolean;
  // handleChange: (name: string, value: string) => void;
}

const ButtonFooter: React.FC<ProfileSidebarProps> = ({ editing }) => {
  const authState = useAppSelector(selectAuth);

  const verifySvg = require('assets/icons/verify.svg');
  const twitterSvg = require('assets/icons/twitter.svg');
  const facebookSvg = require('assets/icons/facebook.svg');
  const instagramSvg = require('assets/icons/instagram.svg');
  const tiktokSvg = require('assets/icons/tiktok.svg');

  const [userName, setUserName] = useState<string>(authState.username || '');
  const [nameFontSize, setNameFontSize] = useState<number>(22);
  const [email, setEmail] = useState<string>(authState.email || '');
  const [about, setAbout] = useState<string>(
    authState.bio ||
      `Hello, I am a beta tester on this app! I come from New York City and have been designing NFTs for 2 months.`
  );
  const [website, setWebsite] = useState<string>(`emiliesmith.com`);

  useEffect(() => {
    if (userName.length > 22) {
      setNameFontSize(22);
    } else if (userName.length > 16) {
      setNameFontSize(16);
    } else {
      setNameFontSize(32);
    }
  }, [userName]);

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box>
          {editing ? (
            <SimpleInputText
              initValue={userName}
              setInput={val => setUserName(val)}
            />
          ) : (
            <TitleText
              style={{
                margin: '1rem 0rem',
                fontSize: `${nameFontSize}px`,
                whiteSpace: 'nowrap',
              }}
            >
              {userName}{' '}
              <img src={verifySvg.default} alt="" width="30px" height="30px" />
            </TitleText>
          )}

          {editing ? (
            <SimpleInputText
              initValue={email}
              setInput={val => setEmail(val)}
            />
          ) : (
            <ParaText style={{ color: '#36899f' }}>@{email}</ParaText>
          )}

          <SmallButton
            text={'beta tester'}
            color={'primary'}
            style={{ padding: '.5rem 1.5rem', margin: '1.5rem 0rem' }}
          />

          <ParaText>Bio:</ParaText>

          {editing ? (
            <SimpleInputText
              initValue={about}
              setInput={val => setAbout(val)}
            />
          ) : (
            <ParaText>{about}</ParaText>
          )}

          <Grid
            container
            style={{ justifyContent: 'space-between', margin: '1.8rem 0px' }}
          >
            <Grid item xs={12} sm={5.8}>
              <NormalButton
                text={'Follow'}
                style={{ width: '100%' }}
                Icon={<Icon src={IC_USER} alt="ic-contact" />}
              />
            </Grid>
            <Grid item xs={12} sm={5.8}>
              <NormalButton
                text={'Contact'}
                color={'yellow'}
                style={{ width: '100%' }}
                Icon={<Icon src={IC_CONTACT} alt="ic-user" />}
              />
            </Grid>
          </Grid>

          <Grid container style={{ margin: '2rem 0rem' }}>
            <Grid item xs={6}>
              <CustomTextBox>
                <TitleText>
                  {authState.followers ? authState.followers.length : 0}
                </TitleText>
                <SmallText style={{ color: '#ddb930' }}>followers</SmallText>
              </CustomTextBox>
            </Grid>
            <Grid item xs={6}>
              <CustomTextBox>
                <TitleText>
                  {authState.following ? authState.following.length : 0}
                </TitleText>
                <SmallText style={{ color: '#ddb930' }}>following</SmallText>
              </CustomTextBox>
            </Grid>
          </Grid>

          <Grid container style={{ margin: '2rem 0rem' }}>
            <Grid item>
              <CustomTextBox>
                <ParaText>Website</ParaText>

                {editing ? (
                  <SimpleInputText
                    initValue={website}
                    setInput={val => setWebsite(val)}
                  />
                ) : (
                  <a href={`//${website}`} target="_blank" rel="noreferrer">
                    <SmallText style={{ color: '#c1c1c1' }}>
                      {website}
                    </SmallText>
                  </a>
                )}
              </CustomTextBox>
            </Grid>
          </Grid>

          <Grid container style={{ margin: '2rem 0rem' }}>
            <Grid item xs={12} style={{ marginBottom: '1rem' }}>
              <ParaText>Stats</ParaText>
            </Grid>

            <Grid item xs={6}>
              <CustomTextBox>
                <TitleText>13%</TitleText>
                <SmallText style={{ color: '#ddb930' }}>Evolution</SmallText>
              </CustomTextBox>
            </Grid>
            <Grid item xs={6}>
              <CustomTextBox>
                <TitleText>14.4k</TitleText>
                <SmallText style={{ color: '#ddb930' }}>Likes</SmallText>
              </CustomTextBox>
            </Grid>

            <Grid item xs={6}>
              <CustomTextBox>
                <TitleText>100k</TitleText>
                <SmallText style={{ color: '#ddb930' }}>Views</SmallText>
              </CustomTextBox>
            </Grid>
            <Grid item xs={6}>
              <CustomTextBox>
                <TitleText>648</TitleText>
                <SmallText style={{ color: '#ddb930' }}>Points</SmallText>
              </CustomTextBox>
            </Grid>
          </Grid>

          <Grid container style={{ margin: '2rem 0rem' }}>
            <Grid item xs={12} style={{ marginBottom: '1rem' }}>
              <ParaText>Social networks</ParaText>
            </Grid>

            {authState?.twitter && (
              <Grid item xs={12} style={{ margin: '.5rem 0rem' }}>
                <NormalButton
                  style={{
                    width: '100%',
                    borderRadius: '30px',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                      src={verifySvg.default}
                      alt=""
                      width="20px"
                      height="20px"
                      style={{ marginRight: '10px' }}
                    />
                    <span>@{authState?.twitter || ''}</span>
                  </Box>
                  <img
                    src={twitterSvg.default}
                    alt=""
                    width="20px"
                    height="20px"
                  />
                </NormalButton>
              </Grid>
            )}

            <Grid item xs={12} style={{ margin: '.5rem 0rem' }}>
              <NormalButton
                style={{
                  width: '100%',
                  borderRadius: '30px',
                  justifyContent: 'space-between',
                }}
              >
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={verifySvg.default}
                    alt=""
                    width="20px"
                    height="20px"
                    style={{ marginRight: '10px' }}
                  />
                  <span>@emliefacebook</span>
                </Box>
                <img
                  src={facebookSvg.default}
                  alt=""
                  width="20px"
                  height="20px"
                />
              </NormalButton>
            </Grid>

            {authState?.instagram && (
              <Grid item xs={12} style={{ margin: '.5rem 0rem' }}>
                <NormalButton
                  style={{
                    width: '100%',
                    borderRadius: '30px',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                      src={verifySvg.default}
                      alt=""
                      width="20px"
                      height="20px"
                      style={{ marginRight: '10px' }}
                    />
                    <span>@{authState?.instagram || ''}</span>
                  </Box>
                  <img
                    src={instagramSvg.default}
                    alt=""
                    width="20px"
                    height="20px"
                  />
                </NormalButton>
              </Grid>
            )}

            <Grid item xs={12} style={{ margin: '.5rem 0rem' }}>
              <NormalButton
                style={{
                  width: '100%',
                  borderRadius: '30px',
                  justifyContent: 'space-between',
                }}
              >
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={verifySvg.default}
                    alt=""
                    width="20px"
                    height="20px"
                    style={{ marginRight: '10px' }}
                  />
                  <span>@emlietiktok</span>
                </Box>
                <img
                  src={tiktokSvg.default}
                  alt=""
                  width="20px"
                  height="20px"
                />
              </NormalButton>
            </Grid>
          </Grid>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default ButtonFooter;
